import React from "react";
import { useSelector } from "react-redux";
import { DashboardPartsInventoryTable } from "../Inventory/Table";
import { useDispatch } from "react-redux";

import { RootState } from "../../../../redux";
import { listPartsRequest } from "../../../../redux/parts/actions";


const DashboardPartsRequests = () => {
    const { parts_requests } = useSelector((state: RootState) => state.parts);
    const dispatch = useDispatch();

    const handleRefresh = () => {
        dispatch(
            listPartsRequest({
                filters: "signed_by:null,delivery_order:",
                part_fields: "",
                excludes: "",
                save_as: "parts_requests"
            })
        );
    };

    React.useEffect(() => {
        handleRefresh();
    }, [dispatch]);

    return (
        <div className="flex flex-col gap-y-5 mt-5 text-black w-full">
            <DashboardPartsInventoryTable
                parts={parts_requests}
                title="Parts Requests"
                description="View all the parts requests"
                save_as="parts_requests"
                handleRefresh={handleRefresh}
            />
        </div>
    );
};

export default DashboardPartsRequests;
